<template>
  <div class="intimate-rule" :style="cssVars()">
    <van-nav-bar class="van-bar" title="" :style="`paddingTop:${barHeight}px`" left-arrow @click-left="handleBack">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
        <span class="tit-left">
          {{ $t('lang.FriendshipLevel.k031') }}
        </span>
      </template>
    </van-nav-bar>
    <div class="main">
      <div class="preface">{{ $t('lang.FriendshipLevel.k015') }}</div>
      <div class="titie1">{{ $t('lang.FriendshipLevel.k023') }}</div>
      <div class="text1">{{ $t('lang.FriendshipLevel.k018') }}</div>
      <div class="titie2">{{ $t('lang.FriendshipLevel.k016') }}</div>
      <div class="text1">{{ $t('lang.FriendshipLevel.k019') }}</div>
      <div class="titie2">{{ $t('lang.FriendshipLevel.k017') }}</div>
      <div class="text1">{{ $t('lang.FriendshipLevel.k020') }}</div>
      <div class="titie1">{{ $t('lang.FriendshipLevel.k024') }}</div>
      <div class="text1">{{ $t('lang.FriendshipLevel.k021') }}</div>
      <div class="titie1">{{ $t('lang.FriendshipLevel.k022') }}</div>
      <div class="text1">{{ $t('lang.FriendshipLevel.k014') }}</div>
    </div>
  </div>
</template>

<script>
import { getBaseFeature } from '@/assets/style/variable'

export default {
  created() {
    this.$client.addEvent('ep_about_bond_page')
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
    handleBack() {
      const query = this.$route.query
      if (query.fromPage && query.fromPage === 'friendship-level') {
        this.$router.replace({
          path: '/friendship-level',
          query: {
            targetUid: query.targetUid,
          },
        })
        return
      }

      this.closeWeb()
    },
  },
}
</script>

<style lang="less" scoped>
.intimate-rule {
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;
  ::v-deep .van-nav-bar__left .tit-left {
    font-family: var(--string-font);
    font-size: var(--fs-20);
    font-weight: var(--fw-900);
    line-height: var(--lh-title-24);
  }
  .main {
    height: 100%;
    padding: 16px 20px;
    .preface {
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-body-20);
      color: #666666;
    }
    .titie1 {
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-700);
      line-height: var(--lh-title-24);
      color: #333333;
      margin-top: 8px;
    }
    .titie2 {
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-700);
      line-height: var(--lh-title-24);
      color: #333333;
      margin-top: 8px;
    }
    .text1 {
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-body-20);
      color: #666666;
      margin-top: 4px;
    }
  }
}
</style>
